export * from './Icon';
//# sourceMappingURL=index.js.map